import { includes } from 'lodash-es'

const safeFonts = [
  'Arial',
  'Arial Black',
  'Comic Sans',
  'Courier New',
  'Georgia',
  'Helvetica',
  'Impact',
  'Lucida',
  'Lucida Console',
  'Palatino',
  'Proxima Nova',
  'Tahoma',
  'Times New Roman',
  'Trebuchet',
  'Verdana'
]

export default function isWebSafeFont(fontName) {
  return includes(safeFonts, fontName)
}
